import { REHYDRATE } from 'redux-persist';
import { LOGGED_OUT } from 'actions/types';
import { SET_CHART_TYPE, SET_SHOW_OVER_TIME_RUNNING_SUM, } from '../actions/types';
import { ChartType } from '../types';
const initialState = {
    chartTypeV2: ChartType.income_spending,
    showOverTimeRunningSum: true,
};
const analyticsReducer = (state = initialState, action) => {
    switch (action.type) {
        case REHYDRATE: {
            const { analytics } = action.payload || {};
            if (analytics)
                return { ...initialState, ...analytics };
            return state;
        }
        case LOGGED_OUT: {
            return initialState;
        }
        case SET_CHART_TYPE: {
            return { ...state, chartTypeV2: action.payload.chartType };
        }
        case SET_SHOW_OVER_TIME_RUNNING_SUM: {
            return {
                ...state,
                showOverTimeRunningSum: action.payload.showOverTimeRunningSum,
            };
        }
        default:
            return state;
    }
};
export default analyticsReducer;
